import { render, staticRenderFns } from "./ShotsOverview.vue?vue&type=template&id=5670dd8c&"
import script from "./ShotsOverview.vue?vue&type=script&lang=js&"
export * from "./ShotsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports